// @ts-nocheck
import React from 'react';
import FollowUps from 'components/access/FollowUps';

const PenlyAccessFollowUps = () => (
    <FollowUps />
);

export default PenlyAccessFollowUps;
